export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'left',
    fixed: 'left',
    width: 110,
    slots: {
      default: 'opt',
    },
  },
  {
    field: 'custName',
    headerAlign: 'center',
    align: 'left',
    minWidth: 150,
    title: that.$l('INDEX.table_label_custName') || '客户',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'endCustName',
    headerAlign: 'center',
    align: 'left',
    minWidth: 150,
    title: that.$l('INDEX.order_form_label_endCustCode') || '终端客户',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'needSplitShipment',
    headerAlign: 'center',
    align: 'center',
    width: 90,
    title: that.$l('shipment_customer_setting_needSplitShipment') || '是否需要重新拆分',
    showHeaderOverflow: true,
    showOverflow: true,
    slots:{
      default: 'needSplitShipment'
    }
  },
  {
    field: 'v_scaleLength',
    headerAlign: 'center',
    align: 'center',
    width: 120,
    title: that.$l('form_label_scaleLength') || '单箱毛净重小数保留位数',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_created_by') || '创建人',
    field: 'createByName',
    headerAlign: 'center',
    align: 'center',
    width: 130,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_created_date') || '创建时间',
    field: 'createTime',
    headerAlign: 'center',
    align: 'center',
    width: 170,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_modified_by') || '修改人',
    field: 'modifyByName',
    headerAlign: 'center',
    align: 'center',
    width: 130,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_modification_date') || '修改时间',
    field: 'modifyTime',
    headerAlign: 'center',
    align: 'center',
    width: 170,
    showHeaderOverflow: true,
    showOverflow: true,
  },
]
